module.exports = __webpack_public_path__ + "img/press-bg-5.443b2dce.svg";